import { produce } from 'immer'
import createReducer from "./reducerUtils"

const initialState = {
    affiliations: null,
    groups: null,
}

const affiliation = {
    setAffiliations(state, action) {
        state.affiliations = action.payload
    },
    setGroups(state, action) {
        state.groups = action.payload
    }
}

export default produce(
    (state, action) => createReducer(state, action, affiliation),
    initialState
)

